module.exports = __webpack_public_path__ + "img/rodrigo.cc950b3c.jpeg";